import {request} from "../config/axios";


export const meApi = (data) => request('post', 'me', {data});
export const modifyMeApi = (data) => request('post', 'modifyMe', {data});
export const modifyPswApi = (data) => request('post', 'modifyPsw', {data});



// WEBPACK FOOTER //
// ./src/api/account.js